import React, {FunctionComponent} from "react";
import {Slide as MTUISlide} from "@material-ui/core";
import {Direction} from "../navigationHook";

type SlideContainerType = {
    timeout: number;
    animationIn: boolean;
    direction: Direction;
};

const Slide: FunctionComponent<SlideContainerType> = ({timeout, animationIn, direction, children}) => (
    <MTUISlide
        timeout={timeout}
        style={{
            position: "absolute",
            width: "100%"
        }}
        in={animationIn}
        direction={direction === Direction.RIGHT ? "right" : "left"}
        mountOnEnter
        unmountOnExit
    >
        <div>
        {children}
        </div>
    </MTUISlide>
);

export default Slide;
